import { render, staticRenderFns } from "./racks.vue?vue&type=template&id=3986178c&scoped=true"
import script from "./racks.vue?vue&type=script&lang=js"
export * from "./racks.vue?vue&type=script&lang=js"
import style0 from "./racks.vue?vue&type=style&index=0&id=3986178c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986178c",
  null
  
)

export default component.exports